<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="'Proceso'" [description]="" [awesomeIcon]="'microchip'">
    <ng-container *ngIf="model">
      <div class="row">
        <div class="col-6 mr-auto">
          <div class="col-12">
            <mat-form-field>
              <input matInput type="text" name="Name" placeholder="Proceso" [(ngModel)]="model.Name" readonly />
            </mat-form-field>
          </div>

          <div class="col-12">
            <div class="row">
              <mat-form-field class="col-6">
                <input matInput type="text" [(ngModel)]="humanfriendlyCronExp" name="Cron"
                  placeholder="Proceso" readonly />
              </mat-form-field>
              <mat-form-field class="col-3">
                <input matInput type="number" [(ngModel)] = "hora"  min="0" max="24" name="FrecuenciaHorasCron" placeholder="cada x hora" (change)="updateCronExpression($event, true)"/>
              </mat-form-field>
              <mat-form-field class="col-3">
                <input matInput type="number" [(ngModel)] = "minutos"  min="0" max="60" name="FrecuenciaMinutosCron" (change)="updateCronExpression($event, false)"
                  placeholder="cada x minuto" />
              </mat-form-field>
            </div>
          </div>

          <div class="col-12">
            <mat-form-field>
              <input matInput type="text" name="NextExecution" placeholder="Siguiente ejecución"
                [ngModel]="parseDateToMoment(model.NextExecution)" readonly />
            </mat-form-field>
          </div>

          <div class="col-12">
            <mat-form-field>
              <input matInput type="text" name="LastExecution" placeholder="Ultima ejecución"
                [ngModel]="parseDateToMoment(model.LastExecution)" readonly />
            </mat-form-field>
          </div>

          <div class="col-12">
            <mat-form-field>
              <input matInput type="text" name="LastJobState" placeholder="Ultimo estado" [ngModel]="model.LastJobState"
                readonly />
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Botonera -->
      <div class="row">
        <div class="col-6 mr-auto">
          <div class="form-group form-button">
            <button class="btn btn-fill btn-success float-right" (click)="updateRecurringJob()">Guardar</button>
            <a class="btn btn-fill btn-danger float-right" routerLink="../">Volver</a>
          </div>
        </div>
      </div>
    </ng-container>
  </app-generic-panel>

  <app-generic-panel [title]="'Consola de la última ejecución'" [description]="" [awesomeIcon]="'terminal'">
    <app-job-selector [placeHolder]="'Procesos'" [recurringJobId]="model && model.Id" [value]="jobId"
      (selectedValueChange)="onSelectedJobChange($event)"></app-job-selector>

    <div class="console-area">
      <div [ngClass]="logs && logs.Active ? 'console active waiting' : 'console'">
        <div class="line-buffer">
          <ng-container *ngIf="logs">
            <ng-container *ngFor="let log of logs.Log">
              <div *ngIf="log.Type === 1; else progressBarLine">
                <div class="line">
                  <span data-moment-title="" title="{{ log.Timestamp }}" data-container="body"
                    [attr.data-original-title]="log.Timestamp">{{
                    toHumanDuration(logs.StartedAt, log.Timestamp)
                    }}</span>
                  {{ log.Text }}
                </div>
              </div>

              <ng-template #progressBarLine>
                <div class="line pb">
                  <span data-moment-title="" title="{{ log.Timestamp }}" data-container="body">{{ log.Name }}</span>
                  <div class="pv" [style.width.%]="log.Progress" [attr.data-value]="log.Progress"></div>
                </div>
              </ng-template>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </app-generic-panel>
</app-generic-container>
